export const sleep = async (ms?: number) => {
    return new Promise((resolve) => {
        const timeout = setTimeout(() => {
            resolve(undefined);
            clearTimeout(timeout);
        }, ms ?? 10);
    });
};
